"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const css_1 = require("@emotion/css");
const AuthMethodSettings_1 = require("./auth-method/AuthMethodSettings");
const TLSSettings_1 = require("./tls/TLSSettings");
const CustomHeaders_1 = require("./custom-headers/CustomHeaders");
const ConfigSection_1 = require("../ConfigSection");
const Auth = ({ selectedMethod, mostCommonMethod, visibleMethods, defaultOptionsOverrides, customMethods, onAuthMethodSelect, basicAuth, TLS, customHeaders, readOnly = false, }) => {
    const styles = {
        container: (0, css_1.css)({
            maxWidth: 578,
        }),
    };
    return (react_1.default.createElement("div", { className: styles.container },
        react_1.default.createElement(ConfigSection_1.ConfigSection, { title: "Authentication" },
            react_1.default.createElement(AuthMethodSettings_1.AuthMethodSettings, { selectedMethod: selectedMethod, mostCommonMethod: mostCommonMethod, customMethods: customMethods, visibleMethods: visibleMethods, defaultOptionsOverrides: defaultOptionsOverrides, onAuthMethodSelect: onAuthMethodSelect, basicAuth: basicAuth, readOnly: readOnly }),
            TLS && react_1.default.createElement(TLSSettings_1.TLSSettings, Object.assign({}, TLS, { readOnly: readOnly })),
            customHeaders && react_1.default.createElement(CustomHeaders_1.CustomHeaders, Object.assign({}, customHeaders, { readOnly: readOnly })))));
};
exports.Auth = Auth;
//# sourceMappingURL=Auth.js.map